import * as React from "react";
import Storage from "../tenant/Storage";


export default function StoragesList() {

    const activeTenant = { _id: null, name: "TUTTI" };

    return (
        <Storage
            showAll={true}
            activeTenant={activeTenant}
        />
    );

}
